import { useEffect, useState } from "react";
import { CartConfigInterface, CartData } from "../../CartTypes";
import { AddProductToCartBox } from ".././CartFooter";
import Button from "../../../Bundles/BundlesComponents/Button";
import { addBundleToCart } from "../../../Bundles/RenderOnStore/utilities";
import { ATTRIBUTE_KEY_SHORTCODES, updateRewardFreeGifts } from "../../../Bundles/constants";

const RewardGift = ({
    cart,
    cartConfig,
    standAlone,
    currency,
    sft,
}: {
    cartConfig: CartConfigInterface;
    cart: CartData;
    currency: string;
    standAlone: boolean;
    sft: string;
}) => {
    const [hasCheckedCartForGift, setHasCheckedCartForGift] = useState(false);

    const checkIfCartQualifies = () => {
        const discountTitles = cart.items
            .flatMap((item) =>
                item.line_level_discount_allocations.map((allocation) => allocation.discount_application?.title),
            )
            .filter(Boolean);

        const bundlesWithTitleAndProductDiscountOff = standAlone
            ? window.kefi_bundles?.bundles_data?.allBundles?.filter(
                  (bundle: any) => discountTitles.includes(bundle?.title) && !bundle?.product_discounts,
              )
            : [];

        if (bundlesWithTitleAndProductDiscountOff?.length > 0) {
            return false;
        }

        const productQuantityMap: any = {};
        const collectionQuantityMap: any = {};
        cart.items.forEach((item) => {
            const { product_id, quantity, collections, properties } = item;

            const optionsLength = properties && properties?._options ? JSON.parse(properties._options).length : 1;

            // product quantity map
            productQuantityMap[`gid://shopify/Product/${product_id}`] =
                (productQuantityMap[`gid://shopify/Product/${product_id}`] || 0) + quantity * optionsLength;

            // collection quantity map
            collections &&
                collections?.forEach((collectionId) => {
                    collectionQuantityMap[collectionId] =
                        (collectionQuantityMap[collectionId] || 0) + quantity * optionsLength;
                });
        });
        console._log("HHH:::", productQuantityMap);
        console._log("HHH:::", collectionQuantityMap);

        let isCartQualified: boolean = false;

        if (cartConfig.metal_bird_config?.product_selection_type == "products") {
            console._log("Products type");
            let combinedQuantityOfProductsInCart = 0;
            let combinedPriceOfProductsInCart = 0;
            cartConfig.metal_bird_config.products.forEach((product) => {
                const pId = product.id;
                combinedQuantityOfProductsInCart += productQuantityMap[pId] || 0;
                const matchingItems = cart.items.filter((i) => i.product_id.toString() == pId?.split?.("/")?.pop());
                matchingItems.forEach((item) => {
                    combinedPriceOfProductsInCart += (item.price / 100 || 0) * (item.quantity || 0);
                });
            });

            console._log("COMB::", combinedQuantityOfProductsInCart);
            console._log("COMB::", combinedPriceOfProductsInCart);
            if (cartConfig.metal_bird_config.qualifier_type == "min_quantity") {
                isCartQualified = combinedQuantityOfProductsInCart >= cartConfig.metal_bird_config.count;
            } else if (cartConfig.metal_bird_config.qualifier_type == "min_price") {
                isCartQualified = combinedPriceOfProductsInCart >= cartConfig.metal_bird_config.count;
            }
        } else if (cartConfig.metal_bird_config?.product_selection_type == "collections") {
            let combinedQuantityOfProductsInCart = 0;
            let combinedPriceOfProductsInCart = 0;

            const matchedCartItemIndexes: Set<number> = new Set();

            cartConfig.metal_bird_config.collections.forEach((coll: any) => {
                cart.items.forEach((item, index) => {
                    if (item?.collections?.includes(coll.id)) {
                        matchedCartItemIndexes.add(index);
                    }
                });
            });

            if (cartConfig.metal_bird_config.qualifier_type === "min_quantity") {
                combinedQuantityOfProductsInCart = Array.from(matchedCartItemIndexes).reduce(
                    (sum: number, index: number) => {
                        const item = cart.items[index];
                        const optionsLength =
                            item.properties && item.properties?._options
                                ? JSON.parse(item.properties._options).length
                                : 1;
                        return sum + (cart.items[index].quantity || 0) * optionsLength;
                    },
                    0,
                );
            }

            if (cartConfig.metal_bird_config.qualifier_type === "min_price") {
                combinedPriceOfProductsInCart = Array.from(matchedCartItemIndexes).reduce(
                    (sum: number, index: number) => {
                        const item = cart.items[index];
                        return sum + (item.price / 100 || 0) * (item.quantity || 0);
                    },
                    0,
                );
            }
            console._log("COMB::", combinedQuantityOfProductsInCart);
            console._log("COMB::", combinedPriceOfProductsInCart);
            if (cartConfig.metal_bird_config.qualifier_type == "min_quantity") {
                isCartQualified = combinedQuantityOfProductsInCart >= cartConfig.metal_bird_config.count;
            } else if (cartConfig.metal_bird_config.qualifier_type == "min_price") {
                isCartQualified = combinedPriceOfProductsInCart >= cartConfig.metal_bird_config.count;
            }
        }

        console._log("QUALFIED::::", isCartQualified);
        return isCartQualified;
    };

    const [isCartQualifiedForGift, setIsCartQualifiedForGift] = useState(false);

    useEffect(() => {
        const res = checkIfCartQualifies();
        setIsCartQualifiedForGift(res);
        setHasCheckedCartForGift(true);
    }, [cart]);

    console._log("HOLO::", isCartQualifiedForGift);

    const [freeGiftProducts, setFreeGiftProducts] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const updatedFreeProducts = await updateRewardFreeGifts(
                cartConfig?.metal_bird_config?.free_gifts || [],
                sft,
                standAlone,
            );
            setFreeGiftProducts(updatedFreeProducts);
        };
        fetchData();
    }, [cartConfig?.metal_bird_config?.free_gifts]);

    // this useeefect is for auto addition of a free gift
    useEffect(() => {
        if (isCartQualifiedForGift && standAlone && hasCheckedCartForGift) {
            const giftAlreadyInCart = cart.items.some(
                (item: any) =>
                    item.properties?.[ATTRIBUTE_KEY_SHORTCODES.__kbd]?.[ATTRIBUTE_KEY_SHORTCODES.__freeGiftRewards] !=
                    null,
            );
            if (giftAlreadyInCart) return;
            const availableVariant = freeGiftProducts
                .flatMap((product: any) => product?.variants || [])
                .find((variant) => variant?.availableForSale);

            if (!availableVariant) return;

            const defaultVariantId = +availableVariant?.id.split("/").pop();

            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    items: [
                        {
                            id: defaultVariantId,
                            quantity: 1,
                            properties: {
                                // [ATTRIBUTE_KEY_SHORTCODES.__freeGiftRewards]: {
                                //     [ATTRIBUTE_KEY_SHORTCODES.cart_id]: cartConfig.cart_id,
                                // },
                                [ATTRIBUTE_KEY_SHORTCODES.__kbd]: {
                                    [ATTRIBUTE_KEY_SHORTCODES.__freeGiftRewards]: {
                                        [ATTRIBUTE_KEY_SHORTCODES.cart_id]: cartConfig.cart_id,
                                    },
                                },
                            },
                        },
                    ],
                }),
            })
                .then((res) => res.json())
                .then((res) => {
                    console._log("Auto-added free gift:", res);
                })
                .catch((err) => {
                    console.error("Failed to auto-add free gift:", err);
                });
        }
    }, [isCartQualifiedForGift, freeGiftProducts, cart.item_count]);

    // this useeefect is for removal of free products if they dont qualify
    useEffect(() => {
        if (!standAlone) return;
        if (!hasCheckedCartForGift) return;
        if (isCartQualifiedForGift) return;

        const updates: { key: string; quantity: number }[] = [];

        cart.items.forEach((item: any) => {
            if (
                item.properties?.[ATTRIBUTE_KEY_SHORTCODES.__kbd]?.[ATTRIBUTE_KEY_SHORTCODES.__freeGiftRewards] != null
            ) {
                updates.push({ key: item.key, quantity: 0 });
            }
        });

        if (updates.length > 0) {
            Promise.all(
                updates.map(({ key, quantity }) =>
                    fetch("/cart/change.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                        body: JSON.stringify({ id: key, quantity }),
                    }),
                ),
            )
                .then(() => {
                    // do nothing
                })
                .catch((err) => {
                    console.error("Failed to update cart items:", err);
                });
        }
    }, [cart, isCartQualifiedForGift]);

    const [addProductToCart, setAddProductToCart] = useState(null);
    const [isAnyGiftBeingAdded, setIsAnyGiftBeingAdded] = useState(false);

    const removeCartItem = async (lineItemKey: string) => {
        await window.originalFetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
        });
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                flexDirection: "column",
            }}
        >
            {freeGiftProducts && freeGiftProducts.length > 0 && (
                <div
                    style={{
                        marginTop: 10,
                        width: "92%",
                        backgroundColor: cartConfig.metal_bird_config?.card_background_color,
                        position: "relative",
                        borderRadius: "14px",
                    }}
                >
                    <div
                        style={{
                            translate: "0 -50%",
                            width: "fit-content",
                            margin: "auto",
                        }}
                    >
                        <p
                            style={{
                                fontSize: "12px",
                                marginBottom: "6px",
                                textAlign: "center",
                                color: cartConfig.metal_bird_config?.text_color,
                                backgroundColor: cartConfig.metal_bird_config?.text_background_color,
                                padding: "2px 20px",
                                borderRadius: "14px",
                                margin: "auto",
                                fontWeight: "600",
                            }}
                        >
                            {isCartQualifiedForGift
                                ? cartConfig.metal_bird_config?.reached_title
                                : cartConfig.metal_bird_config?.unreached_title}
                        </p>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "nowrap",
                            gap: 24,
                            padding: "4px 10px 10px 10px",
                            justifyContent: freeGiftProducts?.length <= 3 ? "center" : "unset",
                            overflowX: freeGiftProducts?.length <= 3 ? "unset" : "auto",
                        }}
                    >
                        {freeGiftProducts?.map((product: any) => {
                            const pIds = freeGiftProducts.map((p: any) => p?.id?.split("/")?.pop());

                            const productId = product.id?.split("/")?.pop();
                            const isInCart = cart.items.some(
                                (item: any) =>
                                    item.product_id == productId &&
                                    item.properties?.[ATTRIBUTE_KEY_SHORTCODES.__kbd]?.[
                                        ATTRIBUTE_KEY_SHORTCODES.__freeGiftRewards
                                    ] != null,
                            );

                            const anyFgInCart = cart.items.some(
                                (item: any) =>
                                    pIds.includes(item.product_id.toString()) &&
                                    item.properties?.[ATTRIBUTE_KEY_SHORTCODES.__kbd]?.[
                                        ATTRIBUTE_KEY_SHORTCODES.__freeGiftRewards
                                    ] != null,
                            );

                            const isProductAvailable = product.variants.some((vv: any) => vv.availableForSale);

                            return (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "8px",
                                        alignItems: "center",
                                    }}
                                    key={product.id}
                                >
                                    <img
                                        src={product?.images?.[0]?.originalSrc}
                                        alt={product.title}
                                        style={{
                                            borderRadius: "50%",
                                            width: "80px",
                                            height: "80px",
                                            border: "1px solid black",
                                            objectFit: "cover",
                                        }}
                                    />

                                    {(isCartQualifiedForGift || !standAlone) && (
                                        <Button
                                            title={
                                                isProductAvailable
                                                    ? anyFgInCart
                                                        ? isInCart
                                                            ? "IN CART"
                                                            : "CHANGE"
                                                        : "ADD"
                                                    : "N/A"
                                            }
                                            disabledCta={isAnyGiftBeingAdded}
                                            onClick={async (e) => {
                                                e?.preventDefault();
                                                e?.stopPropagation();

                                                if (standAlone && isProductAvailable) {
                                                    if (product?.variants?.length > 1) {
                                                        setAddProductToCart({
                                                            ...product,
                                                            selectedVariants: Array(product.quantity || 1).fill(
                                                                product.variants.find(
                                                                    (v: any) => v?.availableForSale == true,
                                                                ) || product.variants[0],
                                                            ),
                                                        });
                                                    } else {
                                                        try {
                                                            setIsAnyGiftBeingAdded(true);
                                                            if (anyFgInCart) {
                                                                const freeGiftCartItems = cart.items.filter(
                                                                    (item: any) =>
                                                                        pIds.includes(item.product_id.toString()) &&
                                                                        item?.properties?.[
                                                                            ATTRIBUTE_KEY_SHORTCODES.__kbd
                                                                        ]?.[
                                                                            ATTRIBUTE_KEY_SHORTCODES.__freeGiftRewards
                                                                        ] != null,
                                                                );

                                                                for (const item of freeGiftCartItems) {
                                                                    await removeCartItem(item.key);
                                                                }
                                                            }
                                                            await addBundleToCart(
                                                                [
                                                                    {
                                                                        ...product,
                                                                        selectedVariants: Array(
                                                                            product?.quantity || 1,
                                                                        ).fill(product.variants[0]),
                                                                    },
                                                                ],
                                                                {
                                                                    [ATTRIBUTE_KEY_SHORTCODES.__freeGiftRewards]: {
                                                                        [ATTRIBUTE_KEY_SHORTCODES.cart_id]:
                                                                            cartConfig.cart_id,
                                                                    },
                                                                },
                                                                "",
                                                                false,
                                                                "",
                                                            );
                                                        } catch (error) {
                                                            console._log("Free gift not added: ", error);
                                                        } finally {
                                                            setIsAnyGiftBeingAdded(false);
                                                        }
                                                    }
                                                }
                                            }}
                                            style={{
                                                padding: "3px 16px",
                                                backgroundColor: isInCart
                                                    ? cartConfig.metal_bird_config?.inline_btn_bg_color
                                                    : cartConfig.metal_bird_config?.outline_btn_bg_color,
                                                color: isInCart
                                                    ? cartConfig.metal_bird_config?.inline_btn_text_color
                                                    : cartConfig.metal_bird_config?.outline_btn_text_color,
                                                border: "none",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                                fontSize: 12,
                                                minHeight: "max-content",
                                                maxHeight: "max-content",
                                                fontWeight: "600",
                                                minWidth: "60px",
                                                maxWidth: "max-content",
                                                textDecoration: isInCart ? "underline" : "unset",
                                                textUnderlineOffset: "2px",
                                            }}
                                        />
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
            {/* @ts-expect-error hack */}
            {addProductToCart?.id && (
                <AddProductToCartBox
                    setVariant={setAddProductToCart}
                    product={addProductToCart}
                    cartConfig={cartConfig}
                    currency={currency}
                    money_format=""
                    addToCartFromCart={addBundleToCart}
                    cart={cart}
                    standAlone={standAlone}
                    isRewardFreeGift={true}
                    allowOnlySingleFG={true}
                />
            )}
        </div>
    );
};

export default RewardGift;
